module.exports = __webpack_public_path__ + "static/img/icon-favorite.894184e.png";